import type React from 'react';
import cx from 'classnames';
import Linker from 'app/shared/modules/Linker';
import { yieldCallback } from '@zillow/yield-callback';
import 'app/shared/modules/navigation/header/HeaderNavMenuItem.scss';

interface HeaderNavMenuItemProps {
  active?: boolean;
  escape?: boolean;
  mainLinkUrl?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const HeaderNavMenuItem: React.FC<HeaderNavMenuItemProps> = ({ active, escape, mainLinkUrl, children, onClick }) => {
  const yieldTransitionTo = yieldCallback((url: string) => {
    window.router.transitionTo(url);
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (escape) {
      return;
    }

    if (onClick) {
      onClick();
      return;
    }

    e.preventDefault();
    if (mainLinkUrl) {
      yieldTransitionTo(mainLinkUrl);
    }
  };

  const linkerCss = cx({
    'HeaderNavMenuItem-item': true,
    active,
  });

  const querylessUriMain = (mainLinkUrl || '').split('?')[0];

  return (
    <li className="HeaderNavMenuItem">
      <Linker
        disabled={active}
        className={linkerCss}
        escape={escape}
        to={querylessUriMain}
        onClick={handleClick}
        linkType="inherit"
      >
        {children}
      </Linker>
    </li>
  );
};

export default HeaderNavMenuItem;
